import { render, staticRenderFns } from "./Gdt.vue?vue&type=template&id=4825a2e3&scoped=true&"
import script from "./Gdt.vue?vue&type=script&lang=js&"
export * from "./Gdt.vue?vue&type=script&lang=js&"
import style0 from "./Gdt.vue?vue&type=style&index=0&id=4825a2e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825a2e3",
  null
  
)

export default component.exports